const { ActionTypes } = require("../constants/action_types");

const initialState = null;

export const onrowClick = (state = initialState, { type, payload }) => {

    switch (type) {
        case ActionTypes.CANDIDATE_ROW_CLICK:
            return payload; //sidebarShow 
        default:
            return state;
    }
};